// WHITE SPACE STRIPPER
const stripWhitespace = (value) => value.trim().replace(/\s+/g, ' ');

export default stripWhitespace;
